import { RefObject, useEffect, useRef } from 'react'

const FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

const visivel = (el: Element): boolean => el.getClientRects().length > 0

export function useModal(aberto: boolean, conteineres: Array<RefObject<HTMLElement | null>>, aoEscapar?: () => void): void {
  const caixas = useRef(conteineres)
  caixas.current = conteineres
  const escapar = useRef(aoEscapar)
  escapar.current = aoEscapar

  useEffect(() => {
    if (!aberto) return undefined
    const anterior = document.activeElement instanceof HTMLElement ? document.activeElement : null
    const rolagem = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const atual = (): HTMLElement | null =>
      caixas.current.map((r) => r.current).find((el): el is HTMLElement => !!el && visivel(el)) ?? null
    atual()?.focus()

    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { escapar.current?.(); return }
      if (e.key !== 'Tab') return
      const caixa = atual()
      if (!caixa) return
      const itens = Array.from(caixa.querySelectorAll<HTMLElement>(FOCAVEIS)).filter(visivel)
      if (!itens.length) { e.preventDefault(); caixa.focus(); return }
      const primeiro = itens[0]
      const ultimo = itens[itens.length - 1]
      const ativo = document.activeElement
      const fora = !ativo || !caixa.contains(ativo)
      if (e.shiftKey && (fora || ativo === primeiro || ativo === caixa)) {
        e.preventDefault()
        ultimo.focus()
      } else if (!e.shiftKey && (fora || ativo === ultimo)) {
        e.preventDefault()
        primeiro.focus()
      }
    }

    document.addEventListener('keydown', aoTeclar)
    return () => {
      document.removeEventListener('keydown', aoTeclar)
      document.body.style.overflow = rolagem
      anterior?.focus()
    }
  }, [aberto])
}

export default useModal
